var React = require('react');

function Messenger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0C3.582 0 0 3.316 0 7.407C0 9.738 1.163 11.817 2.981 13.175V16L5.705 14.505C6.432 14.706 7.202 14.815 8 14.815C12.418 14.815 16 11.499 16 7.408C16 3.317 12.418 0 8 0ZM8.795 9.975L6.758 7.802L2.783 9.975L7.156 5.333L9.243 7.506L13.168 5.333L8.795 9.975Z","fill":"#068DAA"}));
}

Messenger.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Messenger;

Messenger.default = Messenger;
